import { render, staticRenderFns } from "./AddonCreate.vue?vue&type=template&id=5fd21105&"
import script from "./AddonCreate.vue?vue&type=script&lang=js&"
export * from "./AddonCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports